import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../../hooks/snackBar";
import ListaProdutoSeller from "./ListaProduto";
import { saveAs } from "file-saver";
import {
  listarProdutosSeller,
  listarProdutosComSemFiltro,
  gerarExelProdutosSeller,
} from "../../../../services/http/SellerAdminstradorService/categoriaProdutoSellerService";

import "./styles.scss";

const CategoriaProduto = ({ id, subSellerPage }) => {
  const { idEmpresa } = useParams();
  const { addSnackBar } = useSnackBar();
  const [busca, setBusca] = useState("");
  const [produtos, setProdutos] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const CarregarListaProdutos = (pagina) => {
    trackPromise(
      listarProdutosSeller(pagina, idEmpresa).then((res) => {
        if (res.data) {
          setProdutos(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar os produtos",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar os produtos",
        info: "error",
        open: true,
      });
    });
  };

  const CarregarListaProdutosComFiltro = (filtro, pagina) => {
    trackPromise(
      listarProdutosComSemFiltro(idEmpresa, filtro, pagina).then((res) => {
        if (res.data) {
          setProdutos(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar os produtos",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar os produtos",
        info: "error",
        open: true,
      });
    });
  };

  const extrairBase = () => {
    trackPromise(
      gerarExelProdutosSeller(idEmpresa).then((res) => {
        if (res.data) {
          saveAs(res.data, "Produtos-Seller.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base com produtos",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base com fiprodutosliais",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaFilialSeller = (page) => {
    busca != ""
      ? CarregarListaProdutosComFiltro(busca, page)
      : CarregarListaProdutos(page);
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  useEffect(() => {
    if (busca != "") {
      const delayDebounceFn = setTimeout(() => {
        CarregarListaProdutosComFiltro(busca, 1);
      }, 2000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      CarregarListaProdutos(1);
    }
  }, [busca]);

  useEffect(() => {
    CarregarListaProdutos(1);
  }, []);

  return (
    <div>
      <div className="row mt20 ml-1">
        <h1 className="label-second">Produtos Cadastrados</h1>
      </div>

      <div className="row">
        <div className="col-sm-3 col-md-3 col-lg-3">
          <button
            onClick={() => subSellerPage("formulario-produto")}
            className="buton-green btn btn-block btn-lg mt20"
          >
            INCLUIR PRODUTO
          </button>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <button
            onClick={() => subSellerPage("importacao-produto")}
            className="buton-center-green-black-border  btn btn-block btn-lg mt20"
          >
            IMPORTAÇÃO EM MASSA
          </button>
        </div>

        <div className="col-sm-3 col-md-3 col-lg-3">
          <button
            className="buton-white-black-border btn btn-block btn-lg mt20"
            onClick={extrairBase}
          >
            EXTRAIR BASE
          </button>
        </div>
      </div>
      <ListaProdutoSeller
        subSellerPage={subSellerPage}
        response={produtos}
        mudarPagina={mudarPaginaFilialSeller}
        buscar={buscar}
        busca={busca}
      />
    </div>
  );
};

export default CategoriaProduto;
